import { useMutation } from "@apollo/client";

import { parseDateToString } from "~/modules/app/util/dateHelpers";

import { MapEditorObservationMediaPointPanel_ObservationMediaPointUpdateDocument } from "./mutations.generated";

export type ObservationMediaPointUpdateFormData = {
    createdAt: Date;
    speciesIds: string[];
};

export function useUpdateObservationMediaPointMutation() {
    const [mutate, result] = useMutation(MapEditorObservationMediaPointPanel_ObservationMediaPointUpdateDocument);

    const update = (observationMediaPointId: string, { createdAt, speciesIds }: ObservationMediaPointUpdateFormData) =>
        mutate({
            variables: {
                input: {
                    observationMediaPointId,
                    createdAt: parseDateToString(createdAt),
                    speciesIds,
                },
            },
        });

    return [update, result] as const;
}
